import React from "react";
import { Chip } from "@mui/material";

import { PreventiveMaintenanceStatus } from "../types";

interface StatusChipProps {
  status: PreventiveMaintenanceStatus;
}

const STATUS_CONFIG: Record<
  PreventiveMaintenanceStatus,
  {
    label: string;
    color:
      | "success"
      | "primary"
      | "warning"
      | "error"
      | "secondary"
      | "info";
  }
> = {
  ACTIVE: {
    label: "Active",
    color: "primary",
  },
  INACTIVE: {
    label: "Inactive",
    color: "secondary",
  },
  DUE_SOON: {
    label: "Due Soon",
    color: "warning",
  },
  DUE_TODAY: {
    label: "Due Today",
    color: "error",
  },
  OVERDUE: {
    label: "Overdue",
    color: "error",
  },
};

const StatusChip: React.FC<StatusChipProps> = ({ status }) => {
  const config = STATUS_CONFIG[status];

  return (
    <Chip
      label={config.label}
      color={config.color}
      size="small"
      variant={status === "OVERDUE" ? "filled" : "outlined"}
      sx={{
        minWidth: 115,
        fontWeight: 600,
        borderRadius: "8px",
        textTransform: "capitalize",
      }}
    />
  );
};

export default StatusChip;
